module.exports = __webpack_public_path__ + "static/media/edit.1923af5b.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/edit.png
// module id = 7533
// module chunks = 0